import {TextInput} from '@dropbox/dig-components/text_fields';
import {Split} from '@dropbox/dig-foundations';
import {NotificationContent} from 'client';

export const parseAction = (data: string) => {
  try {
    return JSON.parse(data) as NotificationContent;
  } catch {
    return {content: data, to: '/', icon: 'generic', cta: 'View'} as NotificationContent;
  }
};
export const DataInput = ({
  type,
  value,
  error,
  onChange,
}: {
  type: string;
  value: string;
  error?: boolean;
  onChange: (value: string) => void;
}) => {
  const handleGenericChange = (val: string, key: 'content' | 'to') => {
    const existing = parseAction(value || '{}');
    const updated = JSON.stringify({...existing, [key]: val});
    onChange(updated);
  };

  if (type === 'workstream_update') {
    return null;
  }

  if (type === 'generic') {
    const {to, content} = parseAction(value || '{}');
    return (
      <Split gap="4" direction="vertical">
        <Split.Item>
          <TextInput
            isInvalid={error && !content}
            value={content}
            onChange={(e) => handleGenericChange(e.currentTarget.value, 'content')}
            placeholder="Notification message content"
          />
        </Split.Item>
        <Split.Item>
          <TextInput
            isInvalid={error && !to}
            value={to}
            onChange={(e) => handleGenericChange(e.currentTarget.value, 'to')}
            placeholder="Link"
          />
        </Split.Item>
      </Split>
    );
  }

  return (
    <TextInput
      disabled
      isInvalid={error && value.length === 0}
      value={value}
      onChange={(e) => {
        // setData(e.currentTarget.value);
        onChange(e.currentTarget.value);
      }}
      placeholder="Notification message content"
    />
  );
};
